import { useMemo } from 'react';
import { Input, Label } from '@/common/components/FormElements';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

// Renders a set of editable text inputs
// based on the inputs count prop
const TextInputs = _ref => {
  let {
    nameSpace,
    label,
    caption,
    inputsCount = 0,
    inputValues = [],
    inputPlaceholder = 'Enter Text',
    disabled = false,
    onChange
  } = _ref;
  // Ensure that the values array
  // is the same length as the inputs count
  const values = useMemo(() => {
    return Array.from({
      length: inputsCount
    }, (_, idx) => inputValues[idx] || '');
  }, [inputValues, inputsCount]);

  if (inputsCount === 0) {
    return null;
  }

  return /*#__PURE__*/_jsx(Label, {
    headingOnly: true,
    text: label,
    caption: caption,
    className: parentStyles.formField,
    children: /*#__PURE__*/_jsx("div", {
      className: parentStyles.formField__grid,
      children: Array.from({
        length: inputsCount
      }, (_, i) => {
        const prevData = values.slice(0, i);
        const postData = values.slice(i + 1);
        return /*#__PURE__*/_jsx(Input, {
          placeholder: inputPlaceholder,
          defaultValue: values[i] || '',
          disabled: disabled,
          onChange: evt => onChange([...prevData, evt.target.value || '', ...postData])
        }, `${nameSpace}-${i}`);
      })
    })
  });
};

export default TextInputs;